import { render, staticRenderFns } from "./FloatingWidget.vue?vue&type=template&id=8229c3c0&scoped=true&"
import script from "./FloatingWidget.vue?vue&type=script&lang=js&"
export * from "./FloatingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229c3c0",
  null
  
)

export default component.exports